exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-line[data-v-4db90b96]{margin:1rem;height:30px;display:flex;flex-direction:row;align-items:center}.news-title1[data-v-4db90b96]{color:#2d2d2d;font-size:15px;font-weight:600;flex:auto;padding-left:5px}.back-info[data-v-4db90b96]{font-size:25px;color:#a9a9a9}.news-title[data-v-4db90b96]{color:#2d2d2d;font-size:15px;font-weight:600;margin-bottom:1rem;max-height:60px;overflow:hidden;min-height:40px}.news-info[data-v-4db90b96]{justify-content:space-between;font-size:12px;color:#7d7d7d}.detail-info[data-v-4db90b96]{border-top:8px solid #f2f2f2;font-size:14px;padding:1rem;color:#464646;overflow:auto;line-height:1.4rem}.detail-info .content[data-v-4db90b96]{text-indent:2em;word-break:break-all;color:#464646;line-height:24px}.split-info[data-v-4db90b96]{height:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4db90b96","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/overview/NewsDetail.vue
// module id = 957
// module chunks = 0